/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_No_Errors_FoundInputs */



/**
* | output |
* | --- |
* | "No errors found" |
*
* @param {Error_Nav_No_Errors_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_no_errors_found = /** @type {((inputs?: Error_Nav_No_Errors_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_No_Errors_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune erreur trouvee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurden keine Fehler gefunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun errore trovato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибок не обнаружено")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron errores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未发现错误")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラーは見つかりませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई त्रुटि नहीं पाई गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum erro encontrado")
	return /** @type {LocalizedString} */ ("No errors found")
});